// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ReportingIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={1.5}
      d="M14.1 3.3v2.86a1.5 1.5 0 0 0 1.5 1.5h2.85M8.78 17.58v-2.4M12 17.58v-7.15M15.22 17.58V12.7"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={1.5}
      d="M6.24 2.58c-.76 0-1.37.62-1.37 1.37v16.1c0 .78.63 1.41 1.41 1.41H17.8a1.43 1.43 0 0 0 1.43-1.43V7.86c0-.37-.15-.73-.4-.99l-3.95-3.9a1.4 1.4 0 0 0-.99-.4z"
      clipRule="evenodd"
    />
  </svg>,
  "Reporting",
);
export default ReportingIcon;
